<h2 mat-dialog-title>{{ (data?.isUpdate ? 'Update Route' : 'Save Route') | translate }}</h2>

<mat-dialog-content style="padding-top:1vh">
    <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'Name' | translate }}</mat-label>
        <input matInput maxlength="120" [(ngModel)]="selectedName" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'Cameras' | translate }}</mat-label>
        <mat-select multiple [(ngModel)]="selectedCameraIds">
            <mat-option [disabled]="isDisabled(cam)" *ngFor="let cam of data.cameras" [value]="cam._id">
                {{ cam.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'Distance Tolerance' | translate }}</mat-label>
        <input matInput type="number" min="0" step="0.1" [(ngModel)]="distanceToleranceValue" />
        <span matTextSuffix>{{ distanceUnit | translate }}</span>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'Color' | translate }}</mat-label>
        <mat-select [(ngModel)]="selectedColor">
            <mat-option *ngFor="let option of colorOptions" [value]="option.value">
                <span class="color-option">
                    <span class="color-dot" [style.background-color]="option.value"></span>
                    <span>{{ option.label | translate }}</span>
                </span>
            </mat-option>
        </mat-select>
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-raised-button class="green-text" (click)="confirm()">
        {{ (data?.isUpdate ? 'Update' : 'Save') | translate }}
    </button>
    <button mat-button class="red-text" (click)="cancel()">{{ 'Cancel' | translate }}</button>
</mat-dialog-actions>